import React from 'react';
import ReactDOM from 'react-dom/client';
import { pdfjs } from 'react-pdf';
import App from './App';

// PDF.js worker — use CDN to avoid Vite bundling the ~1 MB worker binary.
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// App Bridge 4 is loaded via CDN (<script src="https://cdn.shopify.com/shopifycloud/app-bridge.js">
// in index.html) and auto-initializes from the <meta name="shopify-api-key"> tag.
// No npm package import required — use the window.shopify global directly.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
